<script setup lang="ts">
import { useDriverStatus } from '../composables/driver-status'

const { modalVisible, uiInstructions } = useDriverStatus()

const onSubmit = () => {
	modalVisible.value = false
	if (uiInstructions.value && uiInstructions.value.submitButton) {
		uiInstructions.value.submitButton.onClick()
	}
}
</script>

<template>
	<BModal
		v-model="modalVisible"
		:title="uiInstructions?.title"
		:submit-text="uiInstructions?.submitButton?.text"
		:dismiss-text="uiInstructions?.dismissText"
		:persistent="!uiInstructions?.dismissText"
		@submit="onSubmit"
	>
		<template v-if="uiInstructions">
			<p class="text-body-2 text-on-surface text-center whitespace-pre-line">
				{{ uiInstructions.message }}
			</p>
		</template>
	</BModal>
</template>
